import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { FmTextField } from "../FmTextField";
import classNames from "classnames";

import useStyles from "./FmAutocompleteInput.style";
import { useTranslation } from "react-i18next";

interface FmAutocompleteInputProps {
    data: Array<any>;
    getLabel: (option: any) => string;
    helperText: any;
    error: any;
    setValue: (value: any) => void;
    label: string;
    defaultValue?: any;
    getImageUrl?: (option: any) => string;
    additionalInputProps?: any;
    noOptionsText?: boolean;
    freeSolo?: any;
    value?: any;
    autoSelect?: any;
    onChange?: any;
}

const fontWeights = {
    regular: 400,
    highlighted: 700,
};

const FmAutocompleteInput = React.forwardRef<any, FmAutocompleteInputProps>((props, ref) => {
    const { data, getLabel, helperText, error, setValue, label, onChange, defaultValue, getImageUrl, additionalInputProps, noOptionsText, value, ...rest } =
        props;

    const { t } = useTranslation();
    const classes = useStyles();

    const noOptionNpk = (
        <div className={classes.noOptionsText_container}>
            <span>{t("autoCompleteInput.firstSpan")}</span>
            <span>{t("autoCompleteInput.secondSpan")}</span>
            <span>{t("autoCompleteInput.thirdSpan")}</span>
        </div>
    );
    const noOptionRegular = <div>No Options</div>;
    return (
        <Autocomplete
            defaultValue={defaultValue}
            {...rest}
            options={data}
            value={value}
            getOptionLabel={(option) => getLabel(option)}
            onChange={(e, option) => setValue(option)}
            noOptionsText={noOptionsText ? noOptionNpk : noOptionRegular}
            renderInput={(params) => {
                return (
                    <FmTextField
                        inputRef={ref}
                        {...params}
                        spellCheck={false}
                        autoComplete='true'
                        additionalInputProps={additionalInputProps}
                        label={label}
                        variant={"filled"}
                        error={error}
                        helperText={helperText}
                    />
                );
            }}
            renderOption={(props, option, { inputValue }) => {
                const matches = match(getLabel(option), inputValue);
                const parts = parse(getLabel(option), matches);
                const image = getImageUrl && getImageUrl(option);
                const hasImage = !!image;

                return (
                    <li {...props}>
                        <div className={classNames({ [classes.withImage]: hasImage })}>
                            {image && <img className={classes.itemImage} src={image} alt={inputValue} title={inputValue} />}
                            {parts.map((part, index) => (
                                <span
                                    key={`${part.text}-${index}`}
                                    style={{
                                        fontWeight: part.highlight ? fontWeights.highlighted : fontWeights.regular,
                                    }}
                                >
                                    {part.text}
                                </span>
                            ))}
                        </div>
                    </li>
                );
            }}
        />
    );
});

export default FmAutocompleteInput;
